import React from 'react'
import ListProduct from './ListProduct';

const Categories = ({listItem}) => {
    
    return (
        <main className="grid grid-cols-1 gap-x-6 gap-y-10  pb-10 sm:grid-cols-3  lg:grid-cols-4 lg:gap-x-4 lg:px-0 transition duration-0 hover:duration-150">
          {listItem &&
            listItem.map((item, index) => (
              <div className="bg-white  rounded" key={index}>
                <div className="p-4 flex flex-col items-center transition duration-150 ease-in-out hover:shadow-md">
                  <ListProduct item={item} />
                </div>
              </div>
            ))}
        </main>
      );
}

export default Categories